/* DMoose — Elbow Wraps landing page
 * ---------------------------------------------------------------------------
 * Adapted from the design-reference HTML for Shopify.
 *
 * Differences from the reference build, on purpose:
 *   - Prices arrive as CENTS from Liquid (data-price="8400"), not dollars.
 *   - Selecting a kit rewrites #ewVariantId so the real product form and the
 *     Shop Pay button both submit the chosen variant.
 *   - Money is formatted from window.EW_MONEY_FORMAT (the shop's own format).
 *
 * Everything here degrades safely: a missing node is skipped rather than
 * throwing and taking the sticky bar down with it.
 */
(function () {
  'use strict';

  /* This shop's money_format contains HTML — "<span class=money>$…</span>".
     Every consumer below writes prices via textContent, which renders tags as
     literal text, so the markup is stripped up front. Plain text is all the
     picker needs. */
  var MONEY_FORMAT = (window.EW_MONEY_FORMAT || '${{amount_no_decimals}}').replace(/<[^>]*>/g, '');

  /* Minimal money formatter covering the four Shopify money tokens.
     If the theme already loads Shopify's currency.js, delete this and use
     Shopify.formatMoney instead. */
  function formatMoney(cents) {
    var value = (cents || 0) / 100;
    function withComma(n, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount': return withComma(value, 2);
        case 'amount_no_decimals': return withComma(Math.round(value), 0);
        case 'amount_with_comma_separator':
          return withComma(value, 2).replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1');
        case 'amount_no_decimals_with_comma_separator':
          return withComma(Math.round(value), 0).replace(/,/g, '.');
        default: return '';
      }
    });
  }

  var $ = function (id) { return document.getElementById(id); };
  var opts = Array.prototype.slice.call(document.querySelectorAll('#picker .opt'));

  var heroPrice = $('heroPrice'), heroWas = $('heroWas'), heroSave = $('heroSave');
  var cartPrice = $('cartprice'), instal = $('instal'), mainCta = $('mainCta');
  /* Optional struck compare-at inside the main button (hero setting
     cta_show_compare, pb3). Null on the ew2/pb2 funnels - every use is guarded. */
  var cartWas = $('cartwas');
  var variantInput = $('ewVariantId');
  var stickyPrice = $('stickyPrice'), stickyWas = $('stickyWas'), stickyKit = $('stickyKit');

  function setText(node, text) { if (node) node.textContent = text; }
  function setHidden(node, hidden) { if (node) node.hidden = hidden; }

  /* ---------------------------------------------------------------------------
     VARIANT MODEL
     This product carries the kits as option "Bundles" and colours as "Color",
     so a chosen kit is only half a variant — bundle AND colour together resolve
     to the id we submit. The full matrix is emitted by the section as JSON;
     everything below derives from it rather than from anything typed in.
     ------------------------------------------------------------------------- */
  var VARIANTS = [];
  try {
    var dataNode = document.querySelector('[data-ew-variants]');
    if (dataNode) VARIANTS = JSON.parse(dataNode.textContent) || [];
  } catch (e) {
    /* Malformed data: fall back to the server-rendered row values below rather
       than throwing and taking the sticky bar down with it. */
    VARIANTS = [];
  }

  var colorBtns = Array.prototype.slice.call(document.querySelectorAll('#ewColors .ew-color'));
  var colorNote = document.querySelector('[data-ew-color-note]');
  var pickerEl = $('picker');
  var freeShipThreshold = pickerEl ? parseInt(pickerEl.dataset.freeThreshold, 10) : NaN;

  var current = { bundle: null, color: null };

  function findVariant(bundle, color) {
    for (var i = 0; i < VARIANTS.length; i++) {
      if (VARIANTS[i].bundle === bundle && VARIANTS[i].color === color) return VARIANTS[i];
    }
    return null;
  }
  function firstAvailableFor(bundle) {
    var fallback = null;
    for (var i = 0; i < VARIANTS.length; i++) {
      if (VARIANTS[i].bundle !== bundle) continue;
      if (VARIANTS[i].available) return VARIANTS[i];
      if (!fallback) fallback = VARIANTS[i];
    }
    return fallback;
  }

  /* Re-price every kit row for the chosen colour. Colours are not stocked
     evenly across bundles, so a row can be unavailable in one colour and fine
     in another — the row keeps showing its real price either way. */
  function repriceRows(color) {
    opts.forEach(function (o) {
      var bundle = o.dataset.bundle;
      if (!bundle || !VARIANTS.length) return;
      var v = findVariant(bundle, color) || firstAvailableFor(bundle);
      if (!v) return;

      o.dataset.variantId = v.id;
      o.dataset.price = v.price;
      o.dataset.was = v.was;
      o.dataset.available = String(v.available);

      var radio = o.querySelector('input[type="radio"]');
      if (radio) radio.value = v.id;

      var rowPrice = o.querySelector('[data-ew-rowprice]');
      if (rowPrice) {
        rowPrice.innerHTML = '';
        rowPrice.appendChild(document.createTextNode(formatMoney(v.price)));
        if (v.was > v.price) {
          var s = document.createElement('s');
          s.textContent = formatMoney(v.was);
          rowPrice.appendChild(s);
        }
      }

      var pct = o.querySelector('[data-ew-pct]');
      if (pct) {
        if (v.was > v.price) {
          pct.hidden = false;
          pct.textContent = Math.round(((v.was - v.price) / v.was) * 100) + '% OFF';
        } else {
          pct.hidden = true;
        }
      }

      var ship = o.querySelector('[data-ew-shipline]');
      if (ship && !isNaN(freeShipThreshold)) {
        var free = v.price >= freeShipThreshold;
        ship.classList.toggle('free', free);
        ship.textContent = free
          ? 'FREE Shipping unlocked'
          : 'Free shipping over ' + formatMoney(freeShipThreshold);
      }

      o.classList.toggle('unavailable', !v.available);
    });
  }

  /* Colours that cannot be bought in the selected bundle are hidden outright
     (user preference, 2026-07-17 — previously dimmed/struck through). */
  function syncColorAvailability(bundle) {
    colorBtns.forEach(function (b) {
      var v = findVariant(bundle, b.dataset.color);
      var sellable = !!(v && v.available);
      b.hidden = !sellable;
      b.disabled = !sellable;
      b.setAttribute('aria-pressed', String(b.dataset.color === current.color));
      b.classList.toggle('sel', b.dataset.color === current.color);
    });
  }

  function render() {
    var v = VARIANTS.length ? findVariant(current.bundle, current.color) : null;

    var price, was, available, id;
    if (v) {
      price = v.price; was = v.was; available = v.available; id = v.id;
    } else {
      /* No JSON (or an impossible combination): trust what the server rendered
         on the selected row. */
      var sel = opts.filter(function (o) { return o.classList.contains('sel'); })[0];
      if (!sel) return;
      price = parseInt(sel.dataset.price, 10) || 0;
      was = parseInt(sel.dataset.was, 10) || price;
      available = sel.dataset.available !== 'false';
      id = sel.dataset.variantId;
    }

    /* The line that actually matters. Without it the customer is charged for
       whichever variant Liquid rendered first, not the one they chose. */
    if (variantInput) variantInput.value = id || '';

    /* Variant-image-by-alt: swap the gallery to this variant's tagged images.
       (No-op on the initial render — the server already painted the default
       variant's set, and galleryMain isn't wired until this IIFE finishes.) */
    if (v && v.title) rebuildGallery(v.title);

    setText(heroPrice, formatMoney(price));
    if (was > price) {
      setText(heroWas, formatMoney(was));
      setText(heroSave, 'Save ' + formatMoney(was - price));
      setHidden(heroWas, false);
      setHidden(heroSave, false);
    } else {
      setHidden(heroWas, true);
      setHidden(heroSave, true);
    }

    setText(cartPrice, formatMoney(price));
    setText(instal, formatMoney(Math.round(price / 4)));
    setText(stickyPrice, formatMoney(price));
    setText(stickyKit, current.bundle || '');

    if (stickyWas) {
      if (was > price) { setText(stickyWas, formatMoney(was)); setHidden(stickyWas, false); }
      else { setHidden(stickyWas, true); }
    }
    if (cartWas) {
      if (was > price) { setText(cartWas, formatMoney(was)); setHidden(cartWas, false); }
      else { setHidden(cartWas, true); }
    }

    if (mainCta) {
      mainCta.disabled = !available;
      setText(mainCta, available ? '' : 'Sold out');
      if (available && cartPrice) {
        /* Rebuild "Add to Cart <price>" — setText above cleared it. */
        mainCta.textContent = 'Add to Cart ';
        mainCta.appendChild(cartPrice);
        setText(cartPrice, formatMoney(price));
        /* The compare-at <s> was detached by the same clear; put it back. */
        if (cartWas) mainCta.appendChild(cartWas);
      }
    }

    if (colorNote) {
      var impossible = VARIANTS.length && !v;
      colorNote.hidden = !impossible;
      if (impossible) {
        colorNote.textContent =
          'That colour is not available in this kit. Pick another colour, or another kit.';
      }
    }

    /* Broadcast the selection (pb3 offer bands, sticky, picker legend listen).
       Fires after the initial render and after every kit/colour change.
       Prices are cents; compare_at is null when there is no real saving.
       window.EW_VARIANT keeps the last detail for listeners that bind late. */
    var detail = {
      id: id,
      price: price,
      was: was,
      compare_at: (was > price) ? was : null,
      available: available,
      bundle: current.bundle,
      title: v ? v.title : (current.bundle || '')
    };
    window.EW_VARIANT = detail;
    try {
      document.dispatchEvent(new CustomEvent('ew:variant', { detail: detail }));
    } catch (e) { /* ancient browsers without CustomEvent: nothing listens there */ }
  }

  /* Colour is a base-kit choice only, like the live PDP: bundle kits sell in
     their pictured (first available) colour and the swatch row hides. */
  var colorsWrap = document.getElementById('ewColors');
  var baseBundle = colorsWrap ? colorsWrap.dataset.baseBundle : null;

  function syncColorVisibility() {
    if (!colorsWrap || !baseBundle) return;
    var isBase = current.bundle === baseBundle;
    colorsWrap.hidden = !isBase;
    if (!isBase && VARIANTS.length) {
      var alt = firstAvailableFor(current.bundle);
      if (alt && alt.color !== current.color) {
        current.color = alt.color;
        repriceRows(current.color);
      }
    }
  }

  function selectBundle(opt) {
    opts.forEach(function (o) { o.classList.remove('sel'); });
    opt.classList.add('sel');
    var radio = opt.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;

    current.bundle = opt.dataset.bundle || current.bundle;

    /* If the chosen colour is not sold in this bundle, move to one that is
       rather than leaving an unbuyable combination selected. */
    if (VARIANTS.length && !findVariant(current.bundle, current.color)) {
      var alt = firstAvailableFor(current.bundle);
      if (alt) current.color = alt.color;
    }

    syncColorVisibility();
    syncColorAvailability(current.bundle);
    render();
  }

  function selectColor(color) {
    current.color = color;
    repriceRows(color);
    syncColorAvailability(current.bundle);
    render();
  }

  opts.forEach(function (o) {
    o.addEventListener('click', function () { selectBundle(o); });
  });
  colorBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      if (!b.disabled) selectColor(b.dataset.color);
    });
  });

  /* Seed from what the server rendered as selected. */
  (function init() {
    var sel = opts.filter(function (o) { return o.classList.contains('sel'); })[0] || opts[0];
    if (sel) current.bundle = sel.dataset.bundle || null;
    var selColor = colorBtns.filter(function (b) { return b.classList.contains('sel'); })[0] || colorBtns[0];
    if (selColor) current.color = selColor.dataset.color || null;
    /* The colour picker was removed from the LP (2026-07-17): with no swatch
       buttons, derive the colour from the server-selected variant so bundle +
       colour still resolve to a real variant id, price and gallery set. */
    if (!current.color && VARIANTS.length && variantInput && variantInput.value) {
      for (var i = 0; i < VARIANTS.length; i++) {
        if (String(VARIANTS[i].id) === String(variantInput.value)) { current.color = VARIANTS[i].color; break; }
      }
    }
    if (current.color) repriceRows(current.color);
    if (current.bundle) syncColorAvailability(current.bundle);
    render();
  })();

  /* ---------------------------------------------------------------------------
     GALLERY — variant-image-by-alt, same behaviour as the live new-equipment
     template (dm-nb-variant-multiple.js): each image's alt is a comma-separated
     list of variant titles, and only images whose list contains the selected
     variant's title are shown. Unlike the live JS we trim entries, because the
     real alt data mixes "a,b" and "a, b".
     ------------------------------------------------------------------------- */
  var MEDIA = [];
  try {
    var mediaNode = document.querySelector('[data-ew-media]');
    if (mediaNode) MEDIA = JSON.parse(mediaNode.textContent) || [];
  } catch (e) { MEDIA = []; }

  var galleryMain = document.querySelector('[data-ew-gallery-main]');
  var galleryThumbs = document.querySelector('[data-ew-gallery-thumbs]');
  var lastGalleryTitle = null;

  function mediaForTitle(title) {
    var out = [];
    for (var i = 0; i < MEDIA.length; i++) {
      var entries = String(MEDIA[i].alt || '').split(',');
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].trim() === title) { out.push(MEDIA[i]); break; }
      }
    }
    return out;
  }

  /* The main <img> carries a srcset, and a browser keeps showing the srcset
     candidate when only .src changes - so every swap rewrites both. */
  function setMain(src) {
    if (!galleryMain) return;
    galleryMain.src = src;
    if (galleryMain.hasAttribute('srcset')) {
      galleryMain.srcset = /width=1200/.test(src) ? src.replace('width=1200', 'width=900') + ' 900w, ' + src + ' 1200w' : src;
    }
  }

  /* Scroll the thumb rail (never the page) so a thumb is fully in view. Works
     for the one-row rail and for the pb3 desktop column. */
  function revealThumb(t) {
    if (!galleryThumbs || !t) return;
    var vertical = getComputedStyle(galleryThumbs).flexDirection === 'column';
    var r = galleryThumbs.getBoundingClientRect(), b = t.getBoundingClientRect();
    var pad = vertical ? (parseFloat(getComputedStyle(galleryThumbs).paddingTop) || 8) : 8;
    if (vertical) {
      var top = b.top - r.top + galleryThumbs.scrollTop;
      if (b.top < r.top + pad) galleryThumbs.scrollTo({ top: top - pad, behavior: 'smooth' });
      else if (b.bottom > r.bottom - pad) galleryThumbs.scrollTo({ top: top + b.height - r.height + pad, behavior: 'smooth' });
    } else {
      var left = b.left - r.left + galleryThumbs.scrollLeft;
      if (b.left < r.left + pad) galleryThumbs.scrollTo({ left: left - pad, behavior: 'smooth' });
      else if (b.right > r.right - pad) galleryThumbs.scrollTo({ left: left + b.width - r.width + pad, behavior: 'smooth' });
    }
  }

  function rebuildGallery(title) {
    if (!galleryMain || !MEDIA.length || !title || title === lastGalleryTitle) return;
    var set = mediaForTitle(title);
    /* A variant with no tagged images keeps the current gallery rather than
       going blank — same spirit as the live placeholder fallback. */
    if (!set.length) return;
    lastGalleryTitle = title;

    /* Open on the SECOND image of the set (lifestyle tile), matching the
       server render; first image when the variant has only one. */
    var galleryEl = document.querySelector("[data-ew-gallery]");
    var openOnFirst = galleryEl && galleryEl.getAttribute("data-ew-main") === "first";
    var mainIdx = (set.length > 1 && !openOnFirst) ? 1 : 0;
    setMain(set[mainIdx].src);
    if (galleryThumbs) {
      /* Selection model, like the live PDP: EVERY image in the set gets a
         thumb — including the active one, marked .sel. */
      galleryThumbs.innerHTML = '';
      for (var i = 0; i < set.length; i++) {
        var t = document.createElement('img');
        t.src = set[i].thumb;
        t.setAttribute('data-full', set[i].src);
        t.alt = galleryMain.alt;
        t.width = 300; t.height = 300; t.loading = 'lazy';
        if (i === mainIdx) t.className = 'sel';
        galleryThumbs.appendChild(t);
      }
      /* Jump (not smooth-scroll) back to the start so the new kit's selected
         thumb is in view; the rail's scroll-behavior:smooth would otherwise
         animate from wherever the previous kit left it. */
      galleryThumbs.style.scrollBehavior = 'auto';
      galleryThumbs.scrollTop = 0;
      galleryThumbs.scrollLeft = 0;
      galleryThumbs.style.scrollBehavior = '';
      updateThumbNav();
    }
  }

  /* Thumb click SELECTS into the main slot (delegated: thumbs are rebuilt on
     every variant change). The rail itself never changes — only which thumb
     is highlighted. data-full carries the 1500px source so the main image
     never downgrades to a 300px thumb file. */
  if (galleryThumbs && galleryMain) {
    galleryThumbs.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'IMG') return;
      setMain(t.getAttribute('data-full') || t.src);
      Array.prototype.forEach.call(galleryThumbs.querySelectorAll('img'), function (o) {
        o.classList.toggle('sel', o === t);
      });
      revealThumb(t);
    });
  }

  /* Thumb rail is a one-row slider: small arrows either side, no dots. Arrows
     only show when the rail actually overflows (five or fewer thumbs = no
     arrows), and visibility is re-checked whenever the gallery is rebuilt. */
  var tPrev = document.querySelector('[data-ew-tprev]');
  var tNext = document.querySelector('[data-ew-tnext]');
  function railVertical() { return !!galleryThumbs && getComputedStyle(galleryThumbs).flexDirection === 'column'; }
  function updateThumbNav() {
    if (!galleryThumbs) return;
    var over = railVertical()
      ? galleryThumbs.scrollHeight > galleryThumbs.clientHeight + 4
      : galleryThumbs.scrollWidth > galleryThumbs.clientWidth + 4;
    if (tPrev) tPrev.hidden = !over;
    if (tNext) tNext.hidden = !over;
    var wrap = galleryThumbs.parentElement;
    if (wrap) wrap.classList.toggle('has-nav', over);
  }
  function thumbStep() {
    var img = galleryThumbs && galleryThumbs.querySelector('img');
    var gap = galleryThumbs ? (parseFloat(getComputedStyle(galleryThumbs).gap) || 8) : 8;
    if (!img) return 120;
    return (railVertical() ? img.offsetHeight : img.offsetWidth) + gap;
  }
  function scrollRail(dir) {
    var d = thumbStep() * 2 * dir;
    galleryThumbs.scrollBy(railVertical() ? { top: d, behavior: 'smooth' } : { left: d, behavior: 'smooth' });
  }
  if (tPrev) tPrev.addEventListener('click', function () { scrollRail(-1); });
  if (tNext) tNext.addEventListener('click', function () { scrollRail(1); });
  window.addEventListener('resize', updateThumbNav, { passive: true });
  updateThumbNav();

  /* FAQ groups behave as accordions: opening one closes its siblings. Applies
     to the hero quick answers, the full FAQ and the mini buy-box FAQ. The
     toggle event does not bubble, so listen in the capture phase. */
  ['.herofaq', '.faq2', '.mini'].forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (group) {
      group.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d || d.tagName !== 'DETAILS' || !d.open) return;
        group.querySelectorAll('details[open]').forEach(function (o) {
          if (o !== d) o.open = false;
        });
      }, true);
    });
  });

  /* Sticky add-to-cart.
     The trigger is the PRIMARY BUTTON leaving view, not the hero section
     clearing the viewport. Anchoring to the section leaves most of the page
     with no CTA on mobile. Do not "simplify" this to a fixed scroll offset —
     see the mobile-cro notes in the README. */
  var stickybar = $('stickybar');
  if (stickybar && mainCta) {
    /* The bar also hides once the final CTA section is in view: that section
       has its own full-size button, and the bar was overlapping it at the
       very bottom of the page (there is no footer below it). */
    var finalSec = document.querySelector('.final, [data-ew-sticky-stop]');
    var onScroll = function () {
      var show = mainCta.getBoundingClientRect().bottom < 0;
      if (show && finalSec && finalSec.getBoundingClientRect().top < window.innerHeight) {
        show = false;
      }
      stickybar.classList.toggle('show', show);
      document.body.classList.toggle('stuck', show);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Sticky bar CTA submits the same form, so it always carries the selected kit. */
  var stickyCta = document.querySelector('#stickybar [data-ew-submit]');
  if (stickyCta) {
    stickyCta.addEventListener('click', function (e) {
      var form = $('ProductForm');
      if (form) {
        e.preventDefault();
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  }

  /* ---------------------------------------------------------------------------
     CART DRAWER — adds stay on the page (user request, 2026-07-17).
     Same contract as the theme's product-form.js: POST the form with a
     `sections` list, then hand the response to <cart-drawer>.renderContents(),
     which repaints and opens the drawer. Covers every funnel form: buy box,
     bundle cards, cross-sell tiles (the sticky CTA submits the buy-box form).
     Any failure falls back to the native POST so the customer can always buy.
     ------------------------------------------------------------------------- */
  /* Resolve the drawer at SUBMIT time, not load time: this script renders
     inside content_for_layout (theme.liquid:181) but cart-drawer.js loads
     after it (:211), and defer scripts run in document order — at load the
     <cart-drawer> element exists but is not yet upgraded, renderContents is
     not a function, and gating the binding on it skipped the wiring entirely
     (adds fell through to the native POST and the cart page). By click time
     every deferred script has long since run. */
  function getCartEl() {
    var el = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    return el && typeof el.renderContents === 'function' ? el : null;
  }
  {
    var addForms = document.querySelectorAll('.ew-scope form[action*="/cart/add"]');
    Array.prototype.forEach.call(addForms, function (form) {
      form.addEventListener('submit', function (e) {
        var cartEl = getCartEl();
        if (!cartEl) return; /* genuinely no drawer: allow the native POST */
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;

        var fd = new FormData(form);
        try {
          fd.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
          if (cartEl.setActiveElement) cartEl.setActiveElement(document.activeElement);
        } catch (err) { /* drawer API changed: plain add still works below */ }

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d.status) { form.submit(); return; }
            /* This store's drawer is the Rebuy Smart Cart app. Rebuy watches
               AJAX cart adds and refreshes itself; show() opens it. The
               theme's native drawer is only the fallback if Rebuy is absent,
               so the two never open on top of each other. */
            var rebuy = window.Rebuy && window.Rebuy.SmartCart;
            if (rebuy && typeof rebuy.show === 'function') {
              try { rebuy.show(); } catch (err) { /* Rebuy API changed: count still updates */ }
            } else {
              cartEl.classList.remove('is-empty');
              cartEl.renderContents(d);
            }
            /* Nav "Cart (n)" count. */
            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) {
                Array.prototype.forEach.call(document.querySelectorAll('[data-ew-cart-count]'), function (el) {
                  el.textContent = c.item_count;
                });
              })
              .catch(function () {});
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });
  }
})();
